import { Column, Columns } from '@codeparva/ui-components-library';
import React from 'react';
import {
  desktopscreensize,
  tabletscreensize,
} from '../../../../../../utilities/constants';
import { Icon } from '../../../../../../utilities/icomoon-css';
import { weakKey } from '../../../../../../utilities/weakKey';
import { useThemeContext } from '../hooks/themeContext';
import { WhyChooseUsTypes } from '../WhyChooseUsTypes';
import { getIconsColor, getTextColor } from './colorSelectorHelper';
import {
  whyChooseUsConfig,
  whyChooseUsBgShapeConfig,
  whyChooseUsColumnConfig,
} from './constants';

export const IconDetailsHelper = (
  width: number,
  whyChooseUsIconDetails: WhyChooseUsTypes.TWhyChooseUsIconDetails[]
) => {
  const theme = useThemeContext();
  const {
    iconSize,
    iconSizeMobile,
    iconSizeTabletToDesktop,
    iconSizeAboveDesktop,
  } = whyChooseUsColumnConfig;
  const selectFontSize = () => {
    if (width > desktopscreensize) {
      return iconSizeAboveDesktop;
    } else if (width < desktopscreensize && width > tabletscreensize) {
      return iconSizeTabletToDesktop;
    } else if (width < tabletscreensize) {
      return iconSizeMobile;
    }
    return iconSize;
  };
  const { maxIconRowCount, minIconRowCount } = whyChooseUsConfig;
  const parentIconsRow = [];
  let data = whyChooseUsIconDetails;
  const maxIconsRowLength = Math.ceil(
    whyChooseUsIconDetails.length / maxIconRowCount
  );
  for (let iconRow = 0; iconRow < maxIconsRowLength; iconRow++) {
    const iconsRow = [];
    for (
      let individualIcon = 0;
      individualIcon < data.length;
      individualIcon++
    ) {
      const rowData = data[individualIcon];
      iconsRow.push(
        <Column
          className={`has-text-${getTextColor(theme)} whyChooseUsColumn`}
          key={weakKey(rowData)}
        >
          <div className={`is-${getIconsColor(theme)}`}>
            <Icon name={rowData.icon.iconName} size={selectFontSize()} />
          </div>
          {/* &nbsp;&nbsp;&nbsp; */}
          <h5 key={`${individualIcon}AmenitiesIconsPara`} className="pt-3">
            {rowData.title}
          </h5>
          <p className="iconDescriptionPadding">{rowData.description}</p>
        </Column>
      );
      if (individualIcon >= minIconRowCount) {
        data = data.slice(maxIconRowCount);
        break;
      }
    }
    parentIconsRow.push(
      <Columns className="RowIconColumn" key={`parentIcon${iconRow}`}>
        {iconsRow}
      </Columns>
    );
  }
  return parentIconsRow;
};

export const IconsDetailsTitleBgShapeVariant = ({
  title,
  subTitleDecription,
  leftAllign,
}: WhyChooseUsTypes.TIconsTitleBgShape) => {
  const theme = useThemeContext();
  const checkLeftAllign = (leftAllign: any) => {
    return leftAllign === true ? '' : 'has-text-centered';
  };
  return (
    <Columns className="whyChooseUsColumnsBgShapeVariant">
      <Column
        className={`has-text-${getTextColor(
          theme
        )} titleAndSubTitleColumnBgShapeVariant`}
      >
        <div className="is-flex">
          <span className="whyChooseUsBorder"></span>
          <h3>{title}</h3>
        </div>
        <div
          className={`has-text-${getTextColor(
            theme
          )} pt-5 mt-2 ${checkLeftAllign(leftAllign)} subtitle2`}
        >
          {subTitleDecription}
        </div>
      </Column>
    </Columns>
  );
};
export const IconsDetailsBgShapeVariant = ({
  width,
  whyChooseUsIconDetails,
}: WhyChooseUsTypes.TIconsDetailsBgShape) => {
  const theme = useThemeContext();
  const {
    maxIconRowCount,
    iconSizeTabletToDesktop,
    iconSizeMobile,
    iconSize,
    iconSizeWithMaxIconRowCount,
    restrictIconSizeRowCount,
  } = whyChooseUsBgShapeConfig;
  const selectFontSize = () => {
    if (width < desktopscreensize && width > tabletscreensize) {
      return iconSizeTabletToDesktop;
    } else if (width < tabletscreensize) {
      return iconSizeMobile;
    }
    return whyChooseUsIconDetails.length > restrictIconSizeRowCount
      ? iconSizeWithMaxIconRowCount
      : iconSize;
  };
  return (
    <Columns className="IconColumnsBgVariant">
      {whyChooseUsIconDetails.slice(0, maxIconRowCount).map(data => {
        return (
          <Column className="iconColumn" key={weakKey(data)}>
            <div className={`is-${getIconsColor(theme)}`}>
              <Icon name={data.icon.iconName} size={selectFontSize()} />
            </div>
            &nbsp;&nbsp;&nbsp;
            <div className={`has-text-${getTextColor(theme)}`}>
              <h5>{data.title}</h5>
            </div>
          </Column>
        );
      })}
    </Columns>
  );
};

export const IconsDetailsBgImageVariant = ({
  whyChooseUsIconDetails,
  width,
}: WhyChooseUsTypes.TIconsDetailBgImageSection) => {
  const theme = useThemeContext();

  const {
    maxIconRowCount,
    iconSizeTabletToDesktop,
    iconSizeMobile,
    iconSize,
    iconSizeWithMaxIconRowCount,
    restrictIconSizeRowCount,
  } = whyChooseUsBgShapeConfig;
  const selectFontSize = () => {
    if (width < desktopscreensize && width > tabletscreensize) {
      return iconSizeTabletToDesktop;
    } else if (width < tabletscreensize) {
      return iconSizeMobile;
    }
    return whyChooseUsIconDetails.length > restrictIconSizeRowCount
      ? iconSizeWithMaxIconRowCount
      : iconSize;
  };
  return (
    <Columns className="IconColumnsLeftAllignVariant">
      {whyChooseUsIconDetails.slice(0, maxIconRowCount).map(data => {
        return (
          <Column className="iconColumnLeftAllign" key={weakKey(data)}>
            <div className={`is-${getIconsColor(theme)}`}>
              <Icon name={data.icon.iconName} size={selectFontSize()} />
            </div>
            &nbsp;&nbsp;&nbsp;
            <div className={`has-text-${getTextColor(theme)}`}>
              <h5>{data.title}</h5>
            </div>
          </Column>
        );
      })}
    </Columns>
  );
};
export const IconDetailsWithBorder = ({
  width,
  whyChooseUsIconDetails,
}: WhyChooseUsTypes.TIconsDetailsBgShape) => {
  const theme = useThemeContext();
  const {
    maxIconRowCount,
    iconSizeTabletToDesktop,
    iconSizeMobile,
    iconSize,
    iconSizeWithMaxIconRowCount,
    restrictIconSizeRowCount,
  } = whyChooseUsBgShapeConfig;
  const selectFontSize = () => {
    if (width < desktopscreensize && width > tabletscreensize) {
      return iconSizeTabletToDesktop;
    } else if (width < tabletscreensize) {
      return iconSizeMobile;
    }
    return whyChooseUsIconDetails.length > restrictIconSizeRowCount
      ? iconSizeWithMaxIconRowCount
      : iconSize;
  };
  const borderColor = (theme: any) => {
    return theme === 'dark' ? 'darkBorder' : 'lightBorder';
  };
  return (
    <div className="iconsList">
      {whyChooseUsIconDetails.slice(0, maxIconRowCount).map(data => {
        return (
          <Column
            key={weakKey(data)}
            className={`amenity ${borderColor(theme)}`}
          >
            <div className={`is-${getIconsColor(theme)}`}>
              <Icon name={data.icon.iconName} size={selectFontSize()} />
            </div>
            <div
              className={`has-text-${getTextColor(theme)} whyChooseUsText mt-4`}
            >
              <h5>{data.title}</h5>
            </div>
          </Column>
        );
      })}
    </div>
  );
};
